




















































































































































































export default {
  name: 'ErrorStateImage',
  props: {
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: '100%',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
